import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { CommonService } from "./views/common/services/common.service";
import { ConfirmationDialogService } from "./views/common/services/confirmation-dialog.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnDestroy, OnInit {
  private sub: any;
  tosterConfig = {
    positionClass: "toast-top-center",
  };

  constructor(
    private slimLoader: SlimLoadingBarService,
    private router: Router,
    private commonService: CommonService,
    private toastr: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
  ) {
    // Listen the navigation events to start or complete the slim bar loading
    this.sub = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.slimLoader.start();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.slimLoader.complete();
        }
      },
      (error: any) => {
        this.slimLoader.complete();
      }
    );
  }

  ngOnDestroy(): any {
    this.sub.unsubscribe();
  }
  ngOnInit() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
    {
      this.router.navigateByUrl("/browser-support");
      // this.confirmationDialogService
      // .browserSupport("Browser not supported", "Use Microsoft Edge, Google Chrome, Mozilla Firefox or Safari (if you are using mac)")
      // .then((isConfirmed) => {

      // this.toastr.error(
      //   "Use Microsoft Edge, Google Chrome, Mozilla Firefox or Safari (if you are using mac)",
      //   "Browser not supported",
      //   this.tosterConfig
      // );
      // })
      // alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
    }
    // else  // If another browser, return 0
    // {
    //     alert('otherbrowser');
    // }
  }

}
